// SPDX-License-Identifier: LicenseRef-Proprietary
import React, { useEffect, useState } from 'react';
import { getItem } from '../lib/storage';
import { useActivityDrawerPosition } from '../hooks/useActivityDrawerPosition';

const ActivityDrawer: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState<any[]>(getItem('vaccineClient.activity', []).slice(-10));
  const { topPosition, isCompactScreen } = useActivityDrawerPosition();

  useEffect(() => {
    const updateItems = () => {
      const allItems = getItem<any[]>('vaccineClient.activity', []);
      const filtered = allItems.filter(item => {
        const msg = item.msg?.toLowerCase() || '';
        return !msg.includes('collapsed') && 
               !msg.includes('expanded') && 
               !msg.includes('switched to tab') &&
               !msg.includes('backend computation results stored') &&
               !msg.includes('updated dashboard settings') &&
               !msg.includes('region');
      });
      setItems(filtered.slice(-10));
    };

    updateItems();
    const id = setInterval(updateItems, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <>
      {/* Fixed button that stays in the same position */}
      <div className="activity-drawer" style={{ position: 'fixed', right: 16, top: topPosition, zIndex: 1100 }}>
        <button className="btn btn-secondary" onClick={() => setOpen(o => !o)}>
          {open ? 'Close Activity' : 'Activity'}
        </button>
      </div>
      
      {/* Separate drawer content that appears below the button */}
      {open && (
        <div className="activity-drawer-content" style={{ 
          position: 'fixed', 
          right: 16, 
          top: topPosition + 40, // Position below the button (button height + margin)
          zIndex: 1100, // Higher than sticky actions to prevent overlay
          width: isCompactScreen ? 280 : 320, 
          maxHeight: isCompactScreen ? 300 : 360, 
          overflow: 'auto',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.1)',
          borderRadius: '8px'
        }}>
          <div className="card" style={{ 
            padding: isCompactScreen ? 8 : 12
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
              <h3 style={{ margin: 0, fontSize: isCompactScreen ? 12 : 14 }}>Recent Activity</h3>
            </div>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {items.slice().reverse().map((e, i) => {
                const date = new Date(e.ts);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const formattedDate = `${day}.${month}. — ${hours}.${minutes}`;
                const displayMsg = e.msg?.replace(/\s*\(blur\)/gi, '') || '';
                return (
                  <li key={i} style={{ padding: isCompactScreen ? '4px 0' : '6px 0', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                    <div style={{ fontSize: isCompactScreen ? 10 : 12, color: '#94a3b8' }}>{formattedDate}</div>
                    <div style={{ fontSize: isCompactScreen ? 11 : 14 }}>{displayMsg}</div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default ActivityDrawer;
